import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from 'app/auth/service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  /**
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   */
  constructor(private _router: Router, private _authenticationService: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        //-> 401 : SESSION ABSENTE, EXPIREE OU COMPTE DESACTIVE -> RETOUR A LA CONNEXION (sauf pendant la connexion elle-meme)
        //-> 403 : PERMISSION REFUSEE SUR UNE ACTION -> LE COMPOSANT AFFICHE LE MESSAGE, ON RESTE SUR LA PAGE
        if (err.status === 401 && !request.url.includes('auth/login')) {
          this._authenticationService.logout();
          this._router.navigate(['/pages/authentication/login'], { queryParams: { returnUrl: this._router.url } });
        }
        // throwError
        const error = err.error.message || err.statusText;
        return throwError(error);
      })
    );
  }
}
